import { Theme } from '@mui/material'

const useStyles = {
  container: (theme: Theme) => ({
    color: theme.palette.common.white,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    flexDirection: 'column',
    gap: '20px',
  }),
  avoidItemContainer: {
    marginBottom: '16px',
    alignItems: 'flex-start',
  },
  imageContainer: {
    paddingRight: '12px',
    display: 'flex',
    alignItems: 'center',
  },
  avoidImage: {
    width: '85%',
    height: 'auto',
    display: 'block',
  },
  textContainer: {
    paddingLeft: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
  },
  text: {
    fontWeight: 400,
    lineHeight: '20px',
    fontSize: '14px',
    letterSpacing: '0.2px',
  },
  textEmphasis: {
    fontWeight: 700,
    fontStyle: 'italic',
  },
}

export default useStyles
